export default "__VITE_ASSET__CZ_qjqpB__"